import { render, staticRenderFns } from "./SurveyBuilderTemplate.vue?vue&type=template&id=4289e79c&scoped=true"
import script from "./SurveyBuilderTemplate.vue?vue&type=script&lang=js"
export * from "./SurveyBuilderTemplate.vue?vue&type=script&lang=js"
import style0 from "./SurveyBuilderTemplate.vue?vue&type=style&index=0&id=4289e79c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4289e79c",
  null
  
)

export default component.exports